import React, { useState, useEffect } from "react";
import YouTube from "react-youtube"
import { Toast } from '../shared/Toast'
import { SlIcon } from "@shoelace-style/shoelace/dist/react";
import detectLanguage from "./promotedPreviewStyles";
import CreativeNameDisplay from "../shared/CreativeNameDisplay";

function PromotedVideoPreview({ preview }) {
  const [playbtn, setPlaybtn] = useState(false)
  const [description, setDescription] = useState("");
  const [isEmbedded,setIsEmbedded] = useState(false)
  const [videoId, setVideoId] = useState("")
  const handleClick = () => {
    let url = preview.button_link;
    if (!/^https?:\/\//i.test(url)) {
      url = `https://${url}`;
    }
    window.open(url, '_blank');
  };
  const handleClickUrl = () => {
    if (preview.click_url !== null && preview.click_url !== undefined && preview.click_url !== '') {
      let url = preview.click_url
      if (!/^https?:\/\//i.test(url)) {
        url = `https://${url}`;
      }
      window.open(url, '_blank');
    }
    else {
      Toast('error', "There is nothing to show")
    }
  }
  useEffect(()=>{
    if (preview.video_urls?.includes('embed')) {
      setVideoId(preview.video_urls?.split('/').pop());
        setIsEmbedded(true)
      }
      else{
        setIsEmbedded(false)
      }
  },[preview.video_urls])


  useEffect(() => {
    setPlaybtn(false)
  }, [preview.img_urls, preview.video_urls])

  useEffect(() => {
    setDescription(prevDescription => {
      let newDescription = preview.description || "";
      if (newDescription?.search("<<>>") !== -1) {
        let text = newDescription.match(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm);
        let text_inside = newDescription.match(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm);
        text_inside = String(text_inside);
        text_inside = text_inside.substring(6, text_inside.length - 4);
        if (text?.length) {
          newDescription = newDescription.replace(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm, `<span  class="hover:cursor-pointer" style="color:blue; text-decoration:underline">${text_inside}</span>`);
        }
        let newtext = newDescription.match(/<<(((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)|(tel:\+91[6-9][0-9]{9}))>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm);
        let linktext = newDescription.match(/>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm);
        const originalString = String(linktext);
        const modifiedString = originalString.substring(2, originalString.length - 4);
        console.log(linktext, originalString, modifiedString, newtext)
        if (newtext?.length) {
          newDescription = newDescription.replace(/<<(((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)|(tel:\+91[6-9][0-9]{9}))>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm, `<span  class="hover:cursor-pointer" style="color:blue; text-decoration:underline">${modifiedString}</span>`);
        }
        let phone_text = newDescription.match(
          /(?<=<<(0\d{10}|[6-9]\d{9})>>)[a-zA-Z0-9-!@#$ %^&*(),.?'":{}|]+(?=<<>>)/gi
        );
        if (phone_text) {
          for (let i of phone_text) {
            newDescription = newDescription.replace(
              /<<(0\d{10}|[6-9]\d{9})>>[a-zA-Z0-9-!@#$%^ &*(),.?'":{}|]+<<>>/i,
              `<span style="color:blue">${i}</span>`
            );
          }
        }
        let subText = newDescription.match(
          /(?<=<<12>>)[a-zA-Z0-9!@#$ %^&*(),.?'":{}|]+(?=<<>>)/gi
        );
        if (subText) {
          for (let i of subText) {
            newDescription = newDescription.replace(
              /<<(12)>>[a-zA-Z0-9!@#$%^ &*(),.?'":{}|]+<<>>/i,
              `<span style="color:blue">${i}</span>`
            );
          }
        }
      }
      return newDescription;
    });
    const handleClickOnSpan = (event) => {
      const target = event.target;
      if (target.tagName.toLowerCase() === "span" && target.classList.contains("hover:cursor-pointer")) {
        const url = preview.click_url;
        if (url) {
          handleClickUrl();
        }
      }
    };

    document.addEventListener("click", handleClickOnSpan);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleClickOnSpan);
    };
  }, [preview.description]);

  const { heading, descrip } = detectLanguage(preview.head_line)
  return (
    <div>
      <CreativeNameDisplay preview={preview} />
      <div className="preview-inner">
        <div className="preview-promoted-video !h-[90%]">
          {!playbtn && preview.video_urls && (preview.img_urls === undefined || preview.img_urls === "") && <section className="flex-1  !h-[40%]" role="video">
            {preview.video_urls && (isEmbedded ? (
              <YouTube
                videoId={videoId}
                opts={{
                  height:"100%",
                  width:"100%",
                  playerVars: {
                    autoplay: 1,
                  },
                }}
                
                className="object-cover"
              />
            ) : (
              <video src={preview.video_urls} style={{ width: "100%", height: "100%",objectFit:"cover"  }} controls />
            ))}
          </section>}
          {playbtn && preview.video_urls && <div className="flex-1  !h-[40%]" role="video">
            {preview.video_urls && (isEmbedded && playbtn ? (
              <YouTube
                videoId={videoId}
                opts={{
                  height:"100%",
                  width:"100%",
                  playerVars: {
                    autoplay: 1,
                  },
                }}
                className="object-cover"
                onReady={(event) => {
                  event.target.playVideo();
                }}
              />
            ) : (
              <video src={playbtn && preview.video_urls} style={{ width: "100%", height: "100%", objectFit:"cover" }} controls autoPlay />
            ))}
          </div>}
          {!playbtn && preview.img_urls && <section className="flex-1 relative !h-[40%]" role="image">
             <div className="w-full h-full">
            {preview.img_urls && <img src={preview.img_urls} alt="" className="w-full !h-[100%]" />}
            {/* <img className="absolute bottom-0 z-10" src="https://d30365bzukh5e5.cloudfront.net/share_content_imgs/telugu_new3_v8.png" alt="way2news-logo" /> */}
              </div> 
            {/* PLAY BUTTON */}
            {!playbtn && preview.video_urls ?
              <div className="w-full h-full flex items-center justify-center absolute top-0 left-0 text-center text-[30px]">
                <sl-icon-button
                  library="lucide"
                  name="play-circle"
                  label="Play Video"
                  style={{ fontSize: "3rem" }}
                  className="shadow"
                  onClick={() => setPlaybtn(true)}></sl-icon-button>
              </div> : null}
            {/* END PLAY BUTTON */}
          </section>}
          {playbtn && preview.video_urls === "" && preview.img_urls && <section className="flex-1 relative  !h-[40%]" role="image-">
            <img src={preview.img_urls} alt="" className="w-full h-full" />
          </section>}
          <div className="p-2">
            <h6 className="hover:cursor-pointer" onClick={handleClickUrl} style={heading}>{preview.head_line}</h6>
            <div dangerouslySetInnerHTML={{ __html: description }} style={descrip} />
            {preview.button_enabled !== 0 ? (preview.btn_text_bgclr !== "#ffffff" ? <div className="d-flex justify-content-center"><button className="btn" style={{ backgroundColor: preview.btn_text_bgclr, color: preview.btn_text_clr, border: `1px solid ${preview.btn_text_clr} ` }} onClick={handleClick}>{preview.button_text}</button></div>
              : <div className="d-flex justify-content-center"> <button onClick={handleClick}>{preview.button_text}</button></div>) : null}
          </div>
        </div>
        <span className="text-xs mb-2 px-2 text-gray-400 flex items-center"><SlIcon library="lucide" name="megaphone"></SlIcon>&nbsp;Sponsored story</span>
        <hr className="!m-0"></hr>

      </div>
    </div>
  );
}

export default PromotedVideoPreview;
